import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [open, setOpen] = useState(false);        // दाखले
  const [teamOpen, setTeamOpen] = useState(false); // पदाधिकारी

  // Click outside dropdown बंद
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.dropdown-wrapper')) {
        setOpen(false);
        setTeamOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <>
      {/* TOP BAR - Vibrant + Official */}
      <div className="top-bar">
        <div className="top-content">
          <span> गट ग्रामपंचायत गावसुत | पंचायत समिती उमरेड, जि. नागपूर</span>
          <a href="tel: 9975977462" className="service-no">
            Helpline no: 9975977462
          </a>
        </div>
      </div>

      {/* HEADER - Clean, Modern, Attractive */}
      <header className="header">
        <div className="header-inner">
          {/* LEFT - Logo + Title with animation */}
          <div className="header-left">
            <img 
              src="/images/sj1.jpg" 
              alt="राष्ट्रीय चिन्ह" 
              className="emblem" 
            />
            <div className="title-box">
              <h1>गट ग्रामपंचायत गावसुत</h1>
              <h3>ISO 9001:2015 प्रमाणित</h3>
            </div>
          </div>

          {/* RIGHT - Personalities with enhanced glow & subtle animation */}
          <div className="header-right personalities">
            <div className="photo-group">
              {[
                "/images/raje.jpg",
                "/images/gandhiji.jpg",
                "/images/tujdojimaharaj.jpeg",
              ].map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt="महापुरुष"
                  className="personality-img glow-frame"
                  style={{ animationDelay: `${i * 0.2}s` }}
                />
              ))}
            </div>
          </div>

          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        </div>

        {/* NAV BAR - 3D hover stronger + gradient */}
        <nav className={`nav-bar ${menuOpen ? "open" : ""}`}>
          <Link to="/" className="nav-item">मुख्य पृष्ठ</Link>
          <Link to="/aboutus" className="nav-item">ग्रामपंचायत-बद्दल</Link>

          <div className="dropdown-wrapper">
            <span onClick={() => setTeamOpen(!teamOpen)} className="nav-item">
              पदाधिकारी व सदस्य ▾
            </span>
            {teamOpen && (
              <div className="dropdown">
                <Link to="/sachiv">ग्रामपंचायत अधिकारी</Link>
                <Link to="/sarpanch">सरपंच</Link>
                <Link to="/upsarpanch">उपसरपंच</Link>
                <Link to="/team">सदस्य / कर्मचारी</Link>
              </div>
            )}
          </div>

          <div className="dropdown-wrapper">
            <span onClick={() => setOpen(!open)} className="nav-item">
              दाखले ▾
            </span>
            {open && (
              <div className="dropdown">
                <Link to="/janm-dakhala">जन्म दाखला</Link>
                <Link to="/mrut-dakhala">मृत्यू दाखला</Link>
                <Link to="/vivah-dakhala">विवाह दाखला</Link>
                <Link to="/namuna">नमुना ८</Link>
              </div>
            )}
          </div>

          <Link to="/devlopment" className="nav-item">विकास कामे</Link>
          <Link to="/gallery" className="nav-item">छायाचित्र</Link>
          <Link to="/contact" className="nav-item">संपर्क</Link>
        </nav>
      </header>

      <style>{`
  body {
    margin: 0;
    font-family: "Noto Sans Devanagari", sans-serif;
    background: #c6e3e6;
    color: #667070;
  }

  /* TOP BAR */
  .top-bar {
    background: #003135;
    color: #e6ffff;
    padding: 8px 0;
    font-weight: 600;
    font-size: 15px;
    border-bottom: 2px solid #0aa3a3;
  }
  .top-content {
    max-width: 1300px;
    margin: auto;
    padding: 0 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .service-no {
    color: #0aa3a3;
    text-decoration: none;
    font-weight: 700;
  }
  .service-no:hover {
    color: #ffffff;
  }

  /* HEADER */
  .header {
    background: linear-gradient(135deg, #003135, #024950);
    box-shadow: 0 4px 14px rgba(0,0,0,0.4);
    border-bottom: 3px solid #0aa3a3;
  }
  .header-inner {
    max-width: 1300px;
    margin: auto;
    padding: 18px 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  /* LEFT */
  .header-left {
    display: flex;
    align-items: center;
    gap: 18px;
  }
  .emblem {
  height: 72px;
  background: transparent;   /* Transparent background */
  mix-blend-mode: lighten;   /* Dark background वर logo smooth दिसेल */
  animation: floatLogo 4s ease-in-out infinite;
  transition: transform 0.4s ease;
}

/* Hover effect */
.emblem:hover {
  transform: scale(1.1) rotate(5deg);
}

/* Automatic floating animation */
@keyframes floatLogo {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

  .title-box {
    background: linear-gradient(135deg, #024950, #0aa3a3);
    color: #ffffff;
    padding: 12px 30px;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
    text-align: center;
  }
  .title-box h1 {
    margin: 0;
    font-size: 27px;
    font-weight: 800;
  }
  .title-box h3 {
    margin: 6px 0 0;
    font-size: 14px;
  }

  /* PERSONALITY IMAGES */
  .personalities .photo-group {
    display: flex;
    gap: 12px;
  }
  .personality-img {
    width: 62px;
    height: 62px;
    border-radius: 50%;
    border: 3px solid #0aa3a3;
    object-fit: cover;
    box-shadow: 
      0 0 12px #0aa3a3,
      0 0 20px #024950;
    transition: 0.3s;
  }
  .personality-img:hover {
    transform: scale(1.15);
    box-shadow: 
      0 0 25px #0aa3a3,
      0 0 40px #0aa3a3;
  }

  /* HAMBURGER */
  .hamburger {
    display: none;
    font-size: 30px;
    color: #0aa3a3;
    cursor: pointer;
  }

  /* NAVBAR */
  .nav-bar {
    background: #024950;
    padding: 12px 0;
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .nav-item {
    color: #e6ffff;
    font-weight: 600;
    padding: 9px 18px;
    border-radius: 8px;
    text-decoration: none;
    transition: 0.3s;
  }

  .nav-item:hover {
    background: #0aa3a3;
    color: #003135;
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(10,163,163,0.4);
  }

  /* DROPDOWN */
  .dropdown-wrapper { position: relative; }

  .dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    background: #003135;
    border: 1px solid #0aa3a3;
    border-radius: 8px;
    min-width: 220px;
    overflow: hidden;
    z-index: 1000;
  }

  .dropdown a {
    display: block;
    padding: 12px 20px;
    color: #e6ffff;
    text-decoration: none;
    border-bottom: 1px solid #024950;
  }

  .dropdown a:hover {
    background: #0aa3a3;
    color: #003135;
    padding-left: 28px;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    .personalities { display: none; }
    .hamburger { display: block; }

    .nav-bar {
      display: none;
      flex-direction: column;
      background: #003135;
      padding: 20px;
    }

    .nav-bar.open { display: flex; }
  }
`}</style>
    </>
  );
};

export default Header;